const firebaseConfig = {
    apiKey: "AIzaSyAH1N9lv8fcGHLLcr1sROmnLuIbStD_Oo4",
    authDomain: "city-riders-bd.firebaseapp.com",
    projectId: "city-riders-bd",
    storageBucket: "city-riders-bd.appspot.com",
    messagingSenderId: "699350923811",
    appId: "1:699350923811:web:d7d6832511258a15da4f96"
  };
  export default firebaseConfig;